import { configurationConstants } from "../_constants";
import { ServiceUtil } from "../_services";

export const configurationActions = {
  isLPXInMaintenance,
};

function isLPXInMaintenance() {
  return (dispatch) => {
    return ServiceUtil.isLPXInMaintenance()
      .then((response) => {         
        dispatch(success(response));
      })
      .catch((error) => failure(error));
  };
  function success(isLPXInMaintenance) {
    return {
      type: configurationConstants.IS_LPX_IN_MAINTENANCE_SUCCESS,
      isLPXInMaintenance,
    };
  }

  function failure(errorString) {
    return { type: configurationConstants.IS_LPX_IN_MAINTENANCE_ERROR };
  }
}



// WEBPACK FOOTER //
// ./src/_actions/configuration.actions.js